import { jsxs as d, jsx as a } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { c as p } from "./cn-DlLpp5ix.js";
const f = "w-[184px]", m = "w-[64px]", w = c(function({ top: r, nav: n, bottom: e, navLabel: o = "a11y.mainNav", collapsed: s = !1, className: i, ...l }, t) {
  return /* @__PURE__ */ d(
    "nav",
    {
      ref: t,
      "aria-label": o,
      "data-component": "Sidebar",
      "data-collapsed": s ? "true" : "false",
      className: p(
        // Vertical rail — sticky to viewport, full-height, scrollable middle.
        "sticky top-0 flex h-screen shrink-0 flex-col border-r border-subtle bg-bg-surface",
        s ? m : f,
        i
      ),
      ...l,
      children: [
        r ? /* @__PURE__ */ a("div", { "data-region": "top", className: "shrink-0 px-3 py-4", children: r }) : null,
        /* @__PURE__ */ a("div", { "data-region": "nav", className: "min-h-0 flex-1 overflow-y-auto px-2 py-2", children: n }),
        e ? /* @__PURE__ */ a("div", { "data-region": "bottom", className: "shrink-0 border-t border-subtle px-3 py-4", children: e }) : null
      ]
    }
  );
});
export {
  w as S
};
//# sourceMappingURL=Sidebar-Boolxs44.js.map
